import { combineReducers } from 'redux';
import { appReducer } from '../app/reducer';
import { loginReducer } from '../page/Login/reducer';
import { searchReducer } from '../page/Search/reducer';
import { searchOverseasReducer } from '../page/SearchOverseas/reducer';
import { sideMenuReducer } from '../components/SideMenu/reducer';
import { userManagementReducer } from 'page/UserManagement/reducer';
import partnerUserManagementReducer from 'page/PartnerUsers/reducer';
import { productManagementReducer } from 'page/ProductManagement/reducer';
import { hubManagementReducer } from 'page/HubManagement/reducer';
import { workflowManagementReducer } from 'page/WorkFlowManagement/reducer';
import { refundBatchConfigReducer } from 'page/RefundBatchConfig/reducer';
import { auditReducer } from 'page/Audit/reducer';
import { requestMessageReducer } from 'page/RequestMessages/reducer';
import { helperReducer } from 'utils/Helper/reducer';

export default combineReducers({
  app: appReducer,
  login: loginReducer,
  search: searchReducer,
  sideMenu: sideMenuReducer,
  userMngt: userManagementReducer,
  partnerUserMngt: partnerUserManagementReducer,
  product: productManagementReducer,
  hubManagement: hubManagementReducer,
  audit: auditReducer,
  request: requestMessageReducer,
  wf: workflowManagementReducer,
  refund: refundBatchConfigReducer,
  helper: helperReducer,
  searchoverseas: searchOverseasReducer
})
